var map = {
	"./open-sans-v16-latin-600.woff": 17,
	"./open-sans-v16-latin-600.woff2": 18,
	"./open-sans-v16-latin-700.woff": 19,
	"./open-sans-v16-latin-700.woff2": 20,
	"./open-sans-v16-latin-800.woff": 21,
	"./open-sans-v16-latin-800.woff2": 22,
	"./open-sans-v16-latin-italic.woff": 23,
	"./open-sans-v16-latin-italic.woff2": 24,
	"./open-sans-v16-latin-regular.woff": 25,
	"./open-sans-v16-latin-regular.woff2": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;